module.exports = __webpack_public_path__ + "img/bg1.28446510.jpg";